module.exports = __webpack_public_path__ + "static/media/founded-in-austin-2019.93b6b096.jpg";